import { Box, ButtonBase, InputBase, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import Shbutton from "../../theme/buttons/Shbutton";
import { DropdownBaseV2 } from "../../theme/dropdowns/Dropdown";
import ShValidatedNumberInput from "../../theme/inputs/ShValidatedNumberInput";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import { useGetCarriersSelectQuery } from "../../../newapi/carrier/carrierSlice";
import { useCreateRepackingOrderMutation } from "../../../newapi/inbound/repackingorders";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../utils/toasts";


const MCreateRepackOrder = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const {data: carriers} = useGetCarriersSelectQuery();
    const [createRepackOrder, {isLoading}] = useCreateRepackingOrderMutation(); 
    // console.log(carriers);

    const [data, setData] = useState({});

    const handleChange = (key, value) => {
        setData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    useEffect(() => {
        if(props.repackLeftToDo) {
            setData((prev) => ({
                ...prev,
                max:props.repackLeftToDo(),
                amount:props.repackLeftToDo(),
                carriers:[],
            }));
        }
    },[props.repackLeftToDo])

    const handleClose = () => {
        setData({});
        props.handleClose();
    }

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleCreateRepackOrder = async() => {
        console.log(props);
        try {
            await createRepackOrder({...data,inboundLineId:props.inboundLineToEdit?.inboundLineId})
            .unwrap()
            .then(res => {
                setData({});
                props.handleClose();
                showToastMessagePostRequest(t,res);
            })
        } catch (e) {
            showToastMessageRequestError(t("create_failed"),t,e);
        }
    }

    return(
        <SHModal
            open={props.open}
            onClose={handleClose}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("create_repackingorder")}</Subheading>

                <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                        borderRadius:6,
                        pl:3,
                        pr:0.5,
                        height:48,
                    }}
                >
                    <Box
                        sx={{
                            flexShrink:0,
                            pr:2,
                        }}
                    >
                        <Text light>{t("amount")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            borderRadius:4,
                            display:"flex",
                        }}
                    >
                        <ShValidatedNumberInput
                            height={40}
                            name="name"
                            value={data.amount}
                            min={0}
                            onChange={handleChange}
                        />
                    </Box>
                </Box>
                {/* <Text light>The data presented will automatically be filtered through the selected warehouses</Text> */}
            </Box>

            {/* BODY */}
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2,
                    pb:0.5,
                }}
            >
                <DropdownBaseV2
                    options={carriers || []}
                    selected={-1}
                    onChange={(selected) => {
                        setData(prev => {
                            const selectedCarrier = carriers[selected];

                            const exists = prev.carriers.find(
                                c => c.id === selectedCarrier.id
                            );

                            if (exists) {
                                // increase amount for existing carrier
                                return {
                                    ...prev,
                                    carriers: prev.carriers.map(c =>
                                        c.id === selectedCarrier.id
                                            ? { ...c, amount: c.amount + 1 }
                                            : c
                                    )
                                };
                            }

                            // add new carrier
                            return {
                                ...prev,
                                carriers: [
                                    ...prev.carriers,
                                    {
                                        ...selectedCarrier,
                                        amount: 1
                                    }
                                ]
                            };
                        });
                    }}
                    resetOnSelection
                    closeOnSelection
                    displayName="name"
                    searchOptions={{
                        enabled: true,
                        placeholder: t("search")
                    }}
                >
                    {({anchorEl,onClick}) => (
                        <ButtonBase
                            onClick={onClick}
                            sx={{
                                background:theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400],
                                color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                fontSize:14,
                                fontWeight:500,
                                fontFamily:"Roboto, sans-serif",
                                height:32,
                                borderRadius:4,
                            }}
                        >
                            {t("add_carrier")}
                        </ButtonBase>
                    )}
                </DropdownBaseV2>
                <Box
                    sx={{
                        display:"flex",
                        flexDirection:"column",
                        gap:1,
                    }}
                >
                    {data?.carriers?.map((carrier,idx) => (
                        <Box
                            key={"carrier"+idx}
                            sx={{
                                width: 1,
                                display: "flex",
                                alignItems: "center",
                                background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                                border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                pr:0.5,
                                py:0.5,
                                pl:2,
                                borderRadius:5,
                            }}
                        >
                            <Box
                                sx={{
                                    minWidth: 190,
                                    width: "fit-content",
                                    maxWidth: "100%",
                                    flexShrink: 0,
                                    display:"flex",
                                    alignItems:'center',
                                    "@media screen and (max-width: 47.9375em)" : {
                                        minWidth:130,
                                    }
                                }}
                            >
                                <Text>{carrier.name}</Text>
                            </Box>
                            <InputBase 
                                value={carrier.amount}
                                onChange={(e) => {
                                    const value = Number(e.target.value);

                                    setData(prev => ({
                                        ...prev,
                                        carriers: prev.carriers.map((c, i) =>
                                            i === idx
                                                ? { ...c, amount: isNaN(value) ? 0 : value }
                                                : c
                                        )
                                    }));
                                }}
                                sx={{
                                    ml:'auto',
                                    backgroundColor: theme.palette.mode === "dark"
                                        ? colors.grey[300]
                                        : colors.grey[100],
                                    height:32,
                                    borderRadius:4,
                                    px:2,
                                    flex:1, 
                                    color:colors.txt["primary"],
                                    lineHeight:`32px`,
                                    "&:focus" : {
                                        border:`1px solid ${
                                            theme.palette.mode === "dark"
                                                ? colors.blue[400]
                                                : colors.primary[400]
                                        }`
                                    },
                                }}
                            />

                            <ButtonBase
                                onClick={() => {
                                    setData(prev => ({
                                        ...prev,
                                        carriers: prev.carriers.filter((_, i) => i !== idx)
                                    }));
                                }}
                                sx={{
                                    ml:0.5,
                                    height:32,
                                    width:32,
                                    borderRadius:4,
                                    background:colors.red[100],
                                    color:colors.red[400],
                                }}
                            >
                                x
                            </ButtonBase>
                        </Box>
                    ))}
                </Box>
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={props.handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton 
                        isLoading={isLoading} 
                        className={"group-btn"} 
                        color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        variant="contained" 
                        onClick={handleCreateRepackOrder}
                    >
                        {t("create")}
                    </Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MCreateRepackOrder;
